import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import * as modifyIntakeActions from './modify-intake-form.actions';
import * as sitesActions from '../../permissions/touchpoint/site-list-folder/site-list.actions';
import ModifyIntakeForm from './modify-intake-form';
import { LoadingPane, ConfirmModalWindow, accessibilityNotificationsEmitter } from '../../common';
import { Title } from '../../layout';
import { toastr } from 'react-redux-toastr';
import { tenantHelpers } from '../../tenantInfo';
import * as intakeFormConstants from './intake-form-constants';
import * as intakeFormsActions from '../intake-forms.actions';
import { validateIntakeFormActions } from '../validate-intake-form';

const publishedValidationMessage = "WARNING: This form is published, but the errors below will prevent anyone using it." +
  " You should retract the form, resolve the issues, then re-publish.";

export class EditIntakeFormComponent extends Component {

  componentDidMount() {
    const { modifyIntakeActions, sitesActions, match, modifyIntake, validateIntakeFormActions } = this.props;
    const { preserveEdits } = modifyIntake;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchForm, validateForm, clearAnswers, selectEditTouchpoint, populateTouchpointEditValues,
      fetchProgramDemographics, populateDemographicsEditValues, preserveEdits : setPreserveEdits, fetchTouchpoint } = modifyIntakeActions;
    const { fetchCompleteSiteList, fetchProgramsForSite } = sitesActions || {};
    const { validateEditedIntakeForm } = validateIntakeFormActions;

    if(!preserveEdits) {
      clearAnswers();
      fetchForm(id)
        .then(form => {
          const { siteId, programId, touchpointQuestions } = form || {};
          validateEditedIntakeForm(id, siteId, programId, Map({}));
          if(this.shouldFetchSite(siteId)) {
            fetchCompleteSiteList();
          }

          if(this.shouldFetchProgram(siteId, programId)) {
            fetchProgramsForSite(siteId);
          }

          // this assumes that there are only questions for a single touchpoint
          if(touchpointQuestions && touchpointQuestions.length > 0) {
            selectEditTouchpoint(id, touchpointQuestions[0].touchpointFormId);
            fetchTouchpoint(siteId, programId, touchpointQuestions[0].touchpointFormId)
            .then(() => {
              populateTouchpointEditValues(id);
            });
          }

          fetchProgramDemographics(siteId, programId)
          .then(() => {
            populateDemographicsEditValues(id, siteId, programId);
          })
          .catch(err => {
            toastr.error(err.errorCode, err.errorMessage);
          });
        });
    }
    setPreserveEdits(false);
    validateForm(['editValues', id], ['intakeForms', id, 'data'], ['editValuesValidation', id]);
  }

  componentWillUpdate(nextProps, nextState) {
    const { modifyIntake, modifyIntakeActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchForm, validateForm, clearAnswers, fetchProgramDemographics, populateDemographicsEditValues } = modifyIntakeActions;
    const { editValues, intakeForms } = modifyIntake;

    const { modifyIntake : newState, match : newMatch } = nextProps;
    const { editValues : newValues, intakeForms : newForms } = newState;
    const { params : newParams } = newMatch || {};
    const { id : newId } = newParams || {};
    const { fetchCompleteSiteList, fetchProgramsForSite } = sitesActions || {};

    if(id !== newId) {
      clearAnswers();
    }
    fetchForm(id)
      .then(form => {
        const { siteId, programId } = form || {};
        if(this.shouldFetchSite(siteId)) {
          fetchCompleteSiteList();
        }

        if(this.shouldFetchProgram(siteId, programId)) {
          fetchProgramsForSite(siteId)
        }

        if(id !== newId) {
          fetchProgramDemographics(siteId, programId)
          .then(() => {
            populateDemographicsEditValues(id, siteId, programId);
          })
          .catch(err => {
            toastr.error(err.errorCode, err.errorMessage);
          });
        }
      });

    if(editValues !== newValues || intakeForms !== newForms)
      validateForm(['editValues', id], ['intakeForms', id, 'data'], ['editValuesValidation', id]);
  }

  componentDidUpdate(prevProps) {
    const { modifyIntakeActions, modifyIntake, validateIntakeFormActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { selectedEditTouchpoint, touchpoints, intakeForms, programDemographics : allProgramsDemographics, showModal, editValues } = modifyIntake;
    const selectedTouchpointId = selectedEditTouchpoint && selectedEditTouchpoint.get(id);
    const touchpointState = touchpoints && touchpoints.get(selectedTouchpointId);
    const { data : selectedTouchpoint } = touchpointState || {};
    const intakeForm = intakeForms && intakeForms.get(id);
    const { siteId, programId } = intakeForm || {};
    const programDemographicsState = allProgramsDemographics && allProgramsDemographics.getIn([siteId, programId]);
    const { data : demographicsValue } = programDemographicsState || {};
    const showConfirmModal = showModal && showModal.get(id);

    const { modifyIntake : oldState, match : oldMatch } = prevProps;
    const { params : oldParams } = oldMatch || {};
    const { id : oldId } = oldParams || {};
    const { selectedEditTouchpoint : prevTouchpointSelection, touchpoints : prevTouchpoints, intakeForms : prevIntakeForms, programDemographics : prevAllProgramsDemographics, showModal : showOldModal } = oldState;
    const prevTouchpointId = prevTouchpointSelection && prevTouchpointSelection.get(oldId);
    const prevTouchpointState = prevTouchpoints && prevTouchpoints.get(prevTouchpointId);
    const { data : prevSelectedTouchpoint } = prevTouchpointState || {};
    const prevIntakeForm = prevIntakeForms && prevIntakeForms.get(oldId);
    const { siteId : prevSiteId, programId : prevProgramId } = prevIntakeForm || {};
    const prevProgramDemographicsState = prevAllProgramsDemographics && prevAllProgramsDemographics.getIn([prevSiteId, prevProgramId]);
    const { data : prevDemographicsValue } = prevProgramDemographicsState || {};
    const previousConfirm = showOldModal && showOldModal.get(oldId);

    const value = editValues && editValues.get(id);
    validateIntakeFormActions.shouldValidateEdit(id, siteId, programId, value);

    if(selectedTouchpoint && intakeForm && (selectedTouchpoint !== prevSelectedTouchpoint || intakeForm !== prevIntakeForm) ) {
      modifyIntakeActions.populateTouchpointEditValues(id);
      validateIntakeFormActions.invalidateEditValidationResult(id);
    }

    if(demographicsValue && (demographicsValue !== prevDemographicsValue || intakeForm !== prevIntakeForm)) {
      modifyIntakeActions.populateDemographicsEditValues(id, siteId, programId);
    }

    if(showConfirmModal && !previousConfirm) {
      var confirmButton = document.getElementById('confirm');
      if(confirmButton) confirmButton.focus();
    }
  }

  shouldFetchSite(siteId) {
    const { sites } = this.props;
    const { siteListState, isFetchingMultiPageSites } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);
    return !isFetchingMultiPageSites && !site;
  }

  shouldFetchProgram(siteId, programId) {
    const { sites } = this.props;
    const { programLists } = sites || {};
    var programsState = siteId && programLists && programLists.get(siteId);
    const { isFetching, data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);
    return !isFetching && !program;
  }

  saveMessage(id) {
    const { modifyIntakeActions, redirectTo } = this.props;
    const { updateForm } = modifyIntakeActions;

    updateForm(id)
      .then(val => {
        toastr.success('Success', 'Intake Form Saved');
        redirectTo('/intake-forms');
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  handleUpdateIntakeForm() {
    const { modifyIntake, modifyIntakeActions, match, redirectTo } = this.props;
    const { params, url } = match || {};
    const { id } = params || {};
    const { editValuesValidation, intakeForms } = modifyIntake;
    const { showEditValidation, showModal } = modifyIntakeActions;
    const intakeFormState = intakeForms && intakeForms.get(id);
    const { data : intakeForm } = intakeFormState || {};

    const validation = editValuesValidation && editValuesValidation.get(id);
    if(validation && validation.length > 0) {
      showEditValidation(id);
      redirectTo(url);
      return;
    }

    if(intakeForm && intakeForm.isPublished) {
      const confirmText =  'This intake form is currently published.' +
        'If you save your changes, they will be made to the published form immediately. Do you want to proceed?';
      accessibilityNotificationsEmitter.assertive(confirmText);
      showModal(id, true);
    }
    else{
      this.saveMessage(id);
    }
  }

  onConfirmModalClose(e, result) {
    const { modifyIntakeActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { showModal } = modifyIntakeActions;
    if(result) {
      this.saveMessage(id);
    }
    showModal(id, false);
  }

  handleUpdateTouchpoint(value) {
    const { modifyIntakeActions, validateIntakeFormActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { selectEditTouchpoint } = modifyIntakeActions || {};

    selectEditTouchpoint(id, value);
    if(!value) {
      validateIntakeFormActions.invalidateEditValidationResult(id);
    }
  }

  handleUpdateValue(sections, updateVal, invalidate) {
    const { modifyIntakeActions, validateIntakeFormActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { updateValue, validateForm } = modifyIntakeActions || {};
    var path = ['editValues', id];
    path.push(...sections);
    updateValue(path, updateVal);
    validateForm(['editValues', id], ['intakeForms', id, 'data'], ['editValuesValidation', id]);
    if(invalidate) {
      validateIntakeFormActions.invalidateEditValidationResult(id);
    }
  }

  handleUpdateOrder(section, name, uniqueId, moveUp) {
    const { modifyIntakeActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { updateOrder } = modifyIntakeActions || {};
    var path = ['editValues', id, section];
    updateOrder(path, name, uniqueId, moveUp);
  }

  handlePreviewIntakeForm() {
    const { redirectTo, match, modifyIntake, modifyIntakeActions } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { intakeForms, editValues } = modifyIntake;
    const formState = intakeForms && intakeForms.get(id);
    const { data } = formState || {};
    const siteId = data && data.siteId;
    const programId = data && data.programId;
    const { fetchCurrentFormPreview, updateModifiedPreviewState } = modifyIntakeActions;

    const value = editValues && editValues.get(id);

    const securityDisabled = value && value.get(intakeFormConstants.securitySection);
    const defaultSecurityDisabled = data && data.disableReCaptcha;
    const disableReCaptcha = securityDisabled !== undefined ? securityDisabled :
      defaultSecurityDisabled !== undefined ? defaultSecurityDisabled : false;

    updateModifiedPreviewState(id, siteId, programId, disableReCaptcha, intakeFormConstants.editStatus.editExisting)
    .then(value => {
      fetchCurrentFormPreview(id, siteId, programId, value);
      redirectTo(`/intake-forms/preview/${id}`);
    });
  }

  render() {
    const { sites, modifyIntake, validateIntake, redirectTo, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { editValues, intakeForms, updateFormState, editValuesValidation, showEditValidation, selectedEditTouchpoint, showModal } = modifyIntake || {};
    const formState = intakeForms && intakeForms.get(id);
    const updateState = updateFormState && updateFormState.get(id);
    const { isFetching, err, data } = formState || { isFetching : false };
    const { isFetching : isSaving } = updateState || { isFetching : false };
    const showConfirmModal = showModal && showModal.get(id);

    const value = editValues && editValues.get(id);
    const defaultValue = new Map(data);
    const errors = editValuesValidation && editValuesValidation.get(id);
    const showErrors = showEditValidation && showEditValidation.get(id);

    const formName = data && data.name;

    const selectedTouchpointId = selectedEditTouchpoint && selectedEditTouchpoint.get(id);


    const siteId = data && data.siteId;
    const { programLists, siteListState, isFetchingMultiPageSites } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);
    const siteName = site ? site.name : '';

    const programId = data && data.programId;
    var programsState = siteId && programLists && programLists.get(siteId);
    const { isFetching : programsLoading, data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);
    const programName = program ? program.name : '';
    const siteAndProgram = !!siteName && !!programName ? ` for ${siteName} / ${programName}` : '';


    var url = tenantHelpers.getParticipantIntakeUrl(id);

    var validationState = validateIntake.getIn(['editFormValidation', id]);
    const { data: intakeValidationResult, isFetching : loadingValidation, err : validationErr } = validationState || { };

    return (
      <LoadingPane
        isLoading={isFetching || programsLoading || isFetchingMultiPageSites}
        err={err}
        loadingMessage={'Loading intake form...'}>
        <Title title="Edit Intake Form"/>
        <ConfirmModalWindow
            show={showConfirmModal}
            title={"Save Intake Form"}
            onClose={(e, result) => this.onConfirmModalClose(e, result) }>
          <div className="form-horizontal survey">
            <p>
              This intake form is currently published at this link:&nbsp;
              <a href={url}>{url}</a>
              &nbsp;If you save your changes, they will be made to the published form immediately. Do you want to proceed?</p>
          </div>
        </ConfirmModalWindow>
        <ModifyIntakeForm
          match={match}
          title={`${formName}${siteAndProgram}`}
          value={value}
          defaultValue={defaultValue}
          siteId={siteId}
          programId={programId}
          updateOrder={(section, name, uniqueId, moveUp) => this.handleUpdateOrder(section, name, uniqueId, moveUp)}
          updateValue={(sections, updateVal, invalidate) => this.handleUpdateValue(sections, updateVal, invalidate)}
          disabled={isFetching}
          errors={errors}
          showErrors={showErrors}
          selectedTouchpointId={selectedTouchpointId}
          updateTouchpoint={(val) => this.handleUpdateTouchpoint(val)}
          isSubmitting={isSaving}
          loadingValidation={loadingValidation}
          validationErr={validationErr}
          intakeValidationResult={intakeValidationResult}
          validationMessage={data && data.isPublished ? publishedValidationMessage : null}
          onSave={() => this.handleUpdateIntakeForm()}
          onCancel={() => redirectTo('/intake-forms')}
          onPreview={() => this.handlePreviewIntakeForm()}
          formMode={intakeFormConstants.editStatus.editExisting} />
      </LoadingPane>
    );
  }
}

EditIntakeFormComponent.propTypes = {
  modifyIntake : PropTypes.any,
  modifyIntakeActions : PropTypes.any,
  redirectTo : PropTypes.func
};

const mapStateToProps = ({ modifyIntake, sites, validateIntake }) => {
  return {
    modifyIntake,
    sites,
    validateIntake
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    intakeFormsActions: bindActionCreators(intakeFormsActions, dispatch),
    validateIntakeFormActions: bindActionCreators(validateIntakeFormActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditIntakeFormComponent);
